export default __webpack_public_path__ + "6c386abe8656c37fef45332dee25dc02.png";